'use strict';

const templates = {
  expandedCard: require('../coupon_card_expanded.html.mustache'),
  sharing: require('../../multiple_offers/sharing.html.mustache'),
  redemption: {
    goBack: require('../redemption_go_back.html.mustache'),
    onlinePromoCode: require('../redemption_online_promo_code.html.mustache'),
    onlineSale: require('../redemption_online_sale.html.mustache'),
    instorePromoCode: require('../redemption_instore_promo_code.html.mustache'),
    instoreSale: require('../redemption_instore_sale.html.mustache'),
    onlineAndInstore: require('../redemption_online_and_instore.html.mustache'),
    mobileDownloadSale: require('../redemption_mobile_download_sale.html.mustache'),
  },
};

const { getQueryStringByName } = require('../../helpers/frontend/query_string');

class CouponCard {
  constructor(el) {
    this.cardClick = this.cardClick.bind(this);
    this.collapse = this.collapse.bind(this);
    this.el = el;
    this.$el = $(this.el);
    this.$description = this.$el.find('.coupon-description');
    this.$contentExpanded = this.$el.find('.coupon-content-expanded');
    this.$multipleOffers = $('#multiple-offers');
    this.isExpanded = false;
    this.coupon = this.$el.data();
    this.place = $('.mpp-container').data();
    this.zeroClipboard = null;
    this.bindings();
    this.checkQueryString();
  }

  bindings() {
    this.$el.on('click', this.cardClick); // Close this coupon card when the user opens another card.
    // This is not only for UX, but also necessary for ZeroClipboard to work properly.

    this.$multipleOffers.on('open-coupon', (event, couponId) => {
      if (couponId === this.coupon.id) {
        return;
      }

      if (this.isExpanded) {
        this.collapse();
      }
    });
    this.$el.find('.coupon-content-top').on('click', () => {
      if (!this.isExpanded) {
        return;
      }

      this.collapse();
    });
    this.$el.on('click', '.arrow-up', this.collapse);
    this.$el.on('click', '.use-online', () => {
      return this.expand({
        useOnline: true,
      });
    });
    this.$el.on('click', '.use-instore', () => {
      return this.expand({
        useInstore: true,
      });
    });
    return this.$el.on('click', '.coupon-go-back', () => {
      return this.expand();
    });
  }

  cardClick() {
    if (this.coupon.inPageFlow !== true) {
      this.open();
      return;
    }

    if (this.isExpanded) {
      return;
    }

    this.$multipleOffers.trigger('open-coupon', this.coupon.id); // The flow is like this:
    // - The first time a user opens a coupon, we open the affiliate link in the same page,
    // and then open a new tab with the same MPP, adding ?coupon_id=id (simulating a "pop under").
    // - For any other clicks after the first one, we check if we've already opened the affiliate link
    // and then we skip the simulated "pop under" and expand the card on the same page.

    const { affiliateUrl } = this.coupon;

    if (affiliateUrl == null || this.hasAlreadyOpenedAttributionLink()) {
      this.expand();
      return;
    }

    const mppUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?coupon_id=${this.coupon.id}`;
    this.markAttributionLinkAsOpened();
    window.open(mppUrl);
    window.location = affiliateUrl;
    return;
  }

  getSessionStorageKey() {
    return `mpp-coupons-attribution-${this.place.placeId}`;
  }

  hasAlreadyOpenedAttributionLink() {
    // checks if we've already opened the attribution link in the past hour during this session
    const openTime =
      typeof sessionStorage !== 'undefined' && sessionStorage !== null
        ? sessionStorage.getItem(this.getSessionStorageKey())
        : undefined;

    if (openTime == null || !(openTime > 0)) {
      return false;
    }

    const diff = new Date().getTime() - openTime;
    return 60 * 60 * 1000 > diff;
  }

  markAttributionLinkAsOpened() {
    return typeof sessionStorage !== 'undefined' && sessionStorage !== null
      ? sessionStorage.setItem(
          this.getSessionStorageKey(),
          new Date().getTime()
        )
      : undefined;
  }

  open() {
    const { affiliateUrl } = this.coupon;
    const couponUrl = `${this.coupon.seeAllUrl}?c=${this.coupon.id}`;

    if (affiliateUrl != null) {
      window.location = affiliateUrl;
      return window.open(couponUrl);
    } else {
      window.location = couponUrl;
      return window.location;
    }
  }

  expand(options = {}) {
    let goBackHtml;
    let redemptionTemplate;
    this.isExpanded = true;
    this.$el.addClass('is-expanded');
    this.$description.removeClass('should-truncate-singleline');
    let showGoBack = false;
    let goBackOnline = false;

    if (options.useOnline === true) {
      if (
        (this.coupon.promoCode != null
          ? this.coupon.promoCode.length
          : undefined) > 0
      ) {
        redemptionTemplate = templates.redemption.onlinePromoCode;
      } else {
        redemptionTemplate = templates.redemption.onlineSale;
      }

      showGoBack = true;
      goBackOnline = true;
    } else if (options.useInstore === true) {
      if (this.coupon.isSale) {
        redemptionTemplate = templates.redemption.instoreSale;
      } else {
        redemptionTemplate = templates.redemption.instorePromoCode;
      }

      showGoBack = true;
    } else {
      redemptionTemplate = (() => {
        switch (this.coupon.displayType) {
          case 'online_sale':
            return templates.redemption.onlineSale;

          case 'instore_promo_code':
            return templates.redemption.instorePromoCode;

          case 'instore_sale':
            return templates.redemption.instoreSale;

          case 'online_instore_promo_code':
            return templates.redemption.onlineAndInstore;

          case 'online_instore_sale':
            return templates.redemption.onlineAndInstore;

          case 'mobile_download_sale':
            return templates.redemption.mobileDownloadSale;

          default:
            return templates.redemption.onlinePromoCode;
        }
      })();
    }

    const basicTemplateData = {};

    basicTemplateData.translate = basicTemplateData.t = () => text =>
      I18n.translate(text);

    const sharingTemplateData = _.extend(basicTemplateData, {
      bhw: 'CouponSharing',
    });

    const sharingHtml = templates.sharing.render(sharingTemplateData);

    if (showGoBack) {
      const goBackTemplateData = _.extend(basicTemplateData, {
        goBackOnline,
      });

      goBackHtml = templates.redemption.goBack.render(goBackTemplateData);
    }

    const afterCopyStrings = {
      openBold: '<strong>',
      closeBold: '</strong>',
      openLink: `<a href=\"${this.coupon.affiliateUrl}\" target=\"_blank\">`,
      closeLink: '</a>',
    };

    const redemptionTemplateData = _.extend(basicTemplateData, {
      goBackHtml,
      promoCode: this.coupon.promoCode,
      affiliateUrl: this.coupon.affiliateUrl,
      productImageUrl: `//${this.coupon.productImageUrl}`,
      strings: {
        afterCopy: I18n.translate(
          'js.modules.coupons.after_copy',
          afterCopyStrings
        ),
        copyFailed: I18n.translate(
          'js.modules.coupons.copy_failed',
          afterCopyStrings
        ),
        printThisCouponAndVisitMerchant: I18n.translate(
          'js.modules.coupons.print_this_coupon_and_visit_merchant',
          {
            merchantName: this.place.placeName,
          }
        ),
        noCodeRequiredInstore: I18n.translate(
          'js.modules.coupons.no_code_required_instore',
          {
            merchantName: this.place.placeName,
          }
        ),
        useOnlineOrInstore: I18n.translate(
          'js.modules.coupons.use_online_or_instore',
          {
            startUseOnline: '<button class="btn-cta btn-small use-online">',
            endUseOnline: '</button>',
            startOr: '<span class="use-online-or-instore">',
            endOr: '</span>',
            startUseInstore: '<button class="btn-cta btn-small use-instore">',
            endUseInstore: '</button>',
          }
        ),
      },
    });

    const redemptionHtml = redemptionTemplate.render(redemptionTemplateData);

    const expandedCardTemplateData = _.extend(basicTemplateData, {
      redemptionHtml,
      sharingHtml,
      displayType: {
        onlinePromoCode: this.coupon.displayType === 'online_promo_code',
        onlineSale: this.coupon.displayType === 'online_sale',
        instoreSale: this.coupon.displayType === 'instore_sale',
        onlineInStorePromoCode:
          this.coupon.displayType === 'online_instore_promo_code',
        onlineInstoreSale: this.coupon.displayType === 'online_instore_sale',
        mobileDownloadSale: this.coupon.displayType === 'mobile_download_sale',
      },
      strings: {
        offerEnds:
          !(this.coupon.endsOn != null
            ? this.coupon.endsOn.length
            : undefined) > 0
            ? null
            : I18n.translate('js.modules.coupons.offer_ends', {
                date: this.coupon.endsOn,
              }),
      },
    });

    const html = templates.expandedCard.render(expandedCardTemplateData);
    this.$contentExpanded.html(html);
    return this.$contentExpanded.slideDown('fast', () => {
      this.initZeroClipboard();
      return this.initSharingButtons();
    });
  }

  collapse() {
    // The way ZeroClipBoard works is by destroying the main window object, not the instance.
    // This is because there can only be one ZeroClipboard element on the page at any time.
    if (typeof ZeroClipboard !== 'undefined' && ZeroClipboard !== null) {
      ZeroClipboard.destroy();
    }

    this.$description.addClass('should-truncate-singleline');
    return this.$contentExpanded.slideUp('fast', () => {
      this.$el.removeClass('is-expanded');
      this.isExpanded = false;
      return this.isExpanded;
    });
  }

  promoCodeCopied() {
    this.$el.find('.copy-promo-code').addClass('hidden');
    this.$el.find('.coupon-after-copy').removeClass('hidden');
    return this.$el.find('.coupon-before-copy').addClass('hidden');
  }

  promoCodeCopyFailed() {
    this.$el.find('.copy-promo-code').addClass('hidden');
    return this.$el.find('.coupon-copy-failed').removeClass('hidden');
  }

  initZeroClipboard() {
    this.zeroClipboard = new ZeroClipboard(this.$el.find('.copy-promo-code'));
    this.zeroClipboard.on('complete', () => {
      this.promoCodeCopied();
      return typeof ZeroClipboard !== 'undefined' && ZeroClipboard !== null
        ? ZeroClipboard.destroy()
        : undefined;
    });
    return this.zeroClipboard.on('wrongflash noflash', () => {
      if (typeof ZeroClipboard !== 'undefined' && ZeroClipboard !== null) {
        ZeroClipboard.destroy();
      }

      return this.initHtml5Clipboard();
    });
  }

  initHtml5Clipboard() {
    return this.$el.on('click', '.copy-promo-code', () => {
      const successful = this.copyToClipboard(this.coupon.promoCode);

      if (successful) {
        return this.promoCodeCopied();
      }

      return this.promoCodeCopyFailed();
    });
  }

  copyToClipboard(text) {
    // based on http://stackoverflow.com/a/30810322/694086
    let successful;
    const textArea = document.createElement('textarea');
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = 0;
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      successful = document.execCommand('copy');
    } catch {
      successful = false;
    }

    document.body.removeChild(textArea);
    return successful;
  }

  initSharingButtons() {
    const slug = window.location.pathname.replace('/biz/', '');
    const options = {
      el: this.$el.find('.offer-sharing'),
      merchantPage: {
        permalink: slug,
        queryParams: {
          coupon_id: this.coupon.id,
        },
        merchantName: this.place.placeName,
        twitterBody: I18n.t('js.modules.coupons.sharing.twitter.body', {
          merchantName: this.place.placeName,
        }),
        emailSubject: I18n.t('js.modules.coupons.sharing.email.subject', {
          merchantName: this.place.placeName,
        }),
        emailBody: I18n.t('js.modules.coupons.sharing.email.body', {
          merchantName: this.place.placeName,
        }),
        campaign: 'UserReferral_mpp_coupons',
      },
    };
    return new Groupon.SharingButtons(options);
  }

  checkQueryString() {
    // if the URL includes ?coupon_id=id, we move this card to the top
    const couponId = getQueryStringByName('coupon_id');

    if (couponId !== this.coupon.id) {
      return;
    }

    const $offerCards = $('#multiple-offers .offer-cards');
    $offerCards.prepend(this.$el);
    const duration = 800;
    return void $('html, body').animate(
      {
        scrollTop: $offerCards.offset().top - 10,
      },
      duration,
      () => {
        return this.expand();
      }
    );
  }
}

module.exports = CouponCard;
